import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "text-left" }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = {
  key: 2,
  class: "tw-flex tw-h-[3px] tw-mt-4 tw-w-full tw-bg-[#b4b4b4]"
}
const _hoisted_4 = { class: "tw-px-[5em] tw-mt-4 tw-mb-[50px]" }
const _hoisted_5 = { class: "bg-white tw-rounded-xl tw-p-4 mb-4" }
const _hoisted_6 = { class: "tw-bg-white tw-rounded-xl tw-p-4" }
const _hoisted_7 = { class: "tw-border-[2px] tw-border-[#d2d2d2] tw-mt-5 tw-mb-5 tw-rounded-xl tw-overflow-hidden tw-text-left" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h2", { class: "tw-bg-[#00a0da] tw-text-white tw-px-4 tw-pt-2.5 tw-pb-2 tw-text-xl tw-font-semibold" }, " AUCTION ", -1)
const _hoisted_9 = { class: "tw-px-4 tw-mb-[25px]" }
const _hoisted_10 = { class: "tw-w-full table-edit tw-mt-[25px] tw-mb-[25px]" }
const _hoisted_11 = { class: "tw-even:bg-gray-50 tw-odd:bg-white" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " AUCTION DATES ", -1)
const _hoisted_13 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_14 = { class: "tw-even:bg-gray-50 tw-odd:bg-white" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " CASE # ID ", -1)
const _hoisted_16 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_17 = { class: "tw-border-[2px] tw-border-[#d2d2d2] tw-mt-5 tw-mb-5 tw-rounded-xl tw-overflow-hidden tw-text-left" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("h2", { class: "tw-bg-[#00a0da] tw-text-white tw-px-4 tw-pt-2.5 tw-pb-2 tw-text-xl tw-font-semibold" }, " PROPERTY VALUE ", -1)
const _hoisted_19 = { class: "tw-px-4 tw-mb-[25px]" }
const _hoisted_20 = { class: "tw-w-full table-edit tw-mt-[25px] tw-mb-[25px]" }
const _hoisted_21 = { class: "tw-even:bg-gray-50 tw-odd:bg-white" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " ESTIMATE MARKET VALUE ", -1)
const _hoisted_23 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_24 = { class: "tw-even:bg-gray-50 tw-odd:bg-white" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " FINAL JUDMENT AMOUNT ", -1)
const _hoisted_26 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_27 = { class: "tw-even:bg-gray-50 tw-odd:bg-white" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " SELL PRICE ", -1)
const _hoisted_29 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_30 = { class: "tw-border-[2px] tw-border-[#d2d2d2] tw-mt-5 tw-mb-5 tw-rounded-xl tw-overflow-hidden tw-text-left" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("h2", { class: "tw-bg-[#00a0da] tw-text-white tw-px-4 tw-pt-2.5 tw-pb-2 tw-text-xl tw-font-semibold" }, " PROPERTY EXPENSES ", -1)
const _hoisted_32 = { class: "tw-px-4 tw-mb-[25px]" }
const _hoisted_33 = { class: "tw-w-full table-edit tw-mt-[25px] tw-mb-[25px]" }
const _hoisted_34 = { class: "tw-even:bg-gray-50 tw-odd:bg-white" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " CLERK FEES ", -1)
const _hoisted_36 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_37 = { class: "tw-even:bg-gray-50 tw-odd:bg-white" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " DOC STAMPS ", -1)
const _hoisted_39 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_40 = { class: "tw-even:bg-gray-50 tw-odd:bg-white" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " ATTORNEY HOURS ", -1)
const _hoisted_42 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_43 = { class: "tw-even:bg-gray-50 tw-odd:bg-white" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " ATTORNEY PAYMENT ", -1)
const _hoisted_45 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_46 = { class: "tw-even:bg-gray-50 tw-odd:bg-white" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " PROPERTY ARRANGMENT % ", -1)
const _hoisted_48 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_49 = { class: "tw-even:bg-gray-50 tw-odd:bg-white" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " PROPERTY ARRAGMENT AMOUNT ", -1)
const _hoisted_51 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_52 = { class: "tw-even:bg-gray-50 tw-odd:bg-white" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " OTHER EXPENSES AMOUNT ", -1)
const _hoisted_54 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_55 = { class: "tw-border-[2px] tw-border-[#d2d2d2] tw-mt-5 tw-mb-5 tw-rounded-xl tw-overflow-hidden tw-text-left" }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("h2", { class: "tw-bg-[#00a0da] tw-text-white tw-px-4 tw-pt-2.5 tw-pb-2 tw-text-xl tw-font-semibold" }, "SELL PROPERTY ", -1)
const _hoisted_57 = { class: "tw-px-4 tw-mb-[25px]" }
const _hoisted_58 = { class: "tw-w-full table-edit tw-mt-[25px] tw-mb-[25px]" }
const _hoisted_59 = { class: "tw-even:bg-gray-50 tw-odd:bg-white" }
const _hoisted_60 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " SELLER AGENT COMMISSION ", -1)
const _hoisted_61 = { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_62 = { class: "tw-even:bg-gray-50 tw-odd:bg-white" }
const _hoisted_63 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " BROKER PAYMENT ", -1)
const _hoisted_64 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_65 = { class: "tw-border-[2px] tw-border-[#d2d2d2] tw-mt-5 tw-mb-5 tw-rounded-xl tw-overflow-hidden tw-text-left" }
const _hoisted_66 = /*#__PURE__*/_createElementVNode("h2", { class: "tw-bg-[#00a0da] tw-text-white tw-px-4 tw-pt-2.5 tw-pb-2 tw-text-xl tw-font-semibold" }, " TEMPORARY MONTHLY PAYMENTS ", -1)
const _hoisted_67 = { class: "tw-px-4 tw-mb-[25px]" }
const _hoisted_68 = { class: "tw-w-full table-edit tw-mt-[25px] tw-mb-[25px]" }
const _hoisted_69 = { class: "tw-even:bg-gray-50 tw-odd:bg-white" }
const _hoisted_70 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " # MONTHS ", -1)
const _hoisted_71 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_72 = { class: "tw-even:bg-gray-50 tw-odd:bg-white" }
const _hoisted_73 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " ANNUAL PROPERTY TAXES ", -1)
const _hoisted_74 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_75 = { class: "tw-even:bg-gray-50 tw-odd:bg-white" }
const _hoisted_76 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " PROPERTY TAXES ", -1)
const _hoisted_77 = { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_78 = { class: "tw-even:bg-gray-50 tw-odd:bg-white" }
const _hoisted_79 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " ANNUAL PROPERTY INSURANCE ", -1)
const _hoisted_80 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_81 = { class: "tw-even:bg-gray-50 tw-odd:bg-white" }
const _hoisted_82 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " PROPERTY INSURANCE ", -1)
const _hoisted_83 = { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_84 = { class: "tw-even:bg-gray-50 tw-odd:bg-white" }
const _hoisted_85 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " ANNUAL FEDERAL TAXES ", -1)
const _hoisted_86 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_87 = { class: "tw-even:bg-gray-50 tw-odd:bg-white" }
const _hoisted_88 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " FEDERAL TAXES ", -1)
const _hoisted_89 = { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_90 = { class: "tw-even:bg-gray-50 tw-odd:bg-white" }
const _hoisted_91 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " ASSOCIATION ANNUAL PAYMENT ", -1)
const _hoisted_92 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_93 = { class: "tw-even:bg-gray-50 tw-odd:bg-white" }
const _hoisted_94 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " ASSOCIATION MONTHLY PAYMENT ", -1)
const _hoisted_95 = { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_96 = { class: "tw-border-[2px] tw-border-[#d2d2d2] tw-mt-5 tw-mb-5 tw-rounded-xl tw-overflow-hidden tw-text-left" }
const _hoisted_97 = /*#__PURE__*/_createElementVNode("div", { class: "tw-bg-[#00a0da] d-flex align-items-center justify-content-between" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "tw-bg-[#00a0da] tw-text-white tw-px-4 tw-pt-2.5 tw-pb-2 tw-text-xl tw-font-semibold" }, " BID & PROFIT "),
  /*#__PURE__*/_createElementVNode("button", {
    id: "openNoteModalProfitRequired",
    class: "btn tw-bg-[#FF0000] tw-text-[#FFFFFF] tw-rounded-lg fw-bold btn-sm",
    style: {"border":"none"},
    "data-bs-toggle": "modal",
    "data-bs-target": "#note-Modal-Profit-Required"
  }, " SEE NOTE ")
], -1)
const _hoisted_98 = { class: "tw-px-4 tw-mb-[25px]" }
const _hoisted_99 = { class: "tw-w-full table-edit tw-mt-[25px] tw-mb-[25px]" }
const _hoisted_100 = { class: "tw-even:bg-gray-50 tw-odd:bg-white" }
const _hoisted_101 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " PLACE BID ", -1)
const _hoisted_102 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_103 = /*#__PURE__*/_createStaticVNode("<div class=\"modal\" id=\"note-Modal-Profit-Required\" tabindex=\"-1\" aria-hidden=\"true\" aria-labelledby=\"label-modal-1\"><div class=\"modal-dialog modal-dialog-centered\"><div class=\"modal-content\"><div class=\"modal-body\"><h3 class=\"text-center\"><b>Note:</b></h3><br><p class=\"text-center\"> - Enter the bid amount you wish to make.<br><br> - The system will calculate and display the profit percentage and dollar amount based on the entered property parameters and calculated expenses. </p><br><div class=\"d-flex justify-content-end\"><button id=\"closeNoteModal\" type=\"button\" class=\"btn tw-bg-[#00a0da] tw-text-[#FFFFFF] tw-rounded-full tw-w-[150px]\" data-bs-dismiss=\"modal\" aria-label=\"Close\"> CLose </button></div></div></div></div></div>", 1)
const _hoisted_104 = { class: "tw-flex tw-items-center tw-justify-center tw-mt-5 tw-gap-5 tw-text-left tw-mb-8" }
const _hoisted_105 = { class: "tw-border-2 tw-border-[#d0d0d0] tw-p-4 tw-rounded-xl tw-px-14" }
const _hoisted_106 = { class: "tw-flex tw-justify-end tw-gap-[30px]" }
const _hoisted_107 = { class: "tw-flex tw-items-center tw-gap-4" }
const _hoisted_108 = /*#__PURE__*/_createElementVNode("h2", { class: "tw-font-bold tw-text-[#545454] tw-opacity-100 tw-text-sm" }, " ESTIMATED NET PROFIT $ ", -1)
const _hoisted_109 = { class: "tw-flex tw-items-center tw-gap-4" }
const _hoisted_110 = /*#__PURE__*/_createElementVNode("h2", { class: "tw-font-bold tw-text-[#545454] tw-opacity-100 tw-text-sm" }, " REQUIRED NET PROFIT % ", -1)
const _hoisted_111 = { class: "tw-flex tw-justify-center tw-items-center tw-mt-7 tw-gap-5 tw-mb-5 tw-w-full" }

import axios from 'axios';
import { ref, computed, toRefs } from 'vue';
import UserService from "@/shared/services/user.service";
import { environment } from "@/environment";
import { currencyFormat } from '@/composables/filters';

//COMPONENTS
import ResidentialView from "./../ResidentialView.vue";
import VueNumberFormat from "vue-number-format";
import FindA from "@/components/admin/Residential/FindA/FindA.vue";
import MLO from "@/components/admin/Residential/MLO/MLO.vue";
import PropertyInformation from '@/components/admin/Investment/PropertyInformation.vue';

import { useToast } from "@/composables/useToast";
import { months } from 'moment';
import SheetPropertyFlip from '../economicSheet/SheetPropertyFlip.vue';
import SheetForeignFlipReady from '../economicSheet/SheetForeignFlipReady.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'FlipPropertyReady',
  props: {
  header: {
    type: Boolean,
    default: true,
  },
  foreign: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const props = __props;

const toast = useToast();


const { foreign }: any = toRefs(props)
//VARIABLES
const url = environment.URL_API;
const loading = ref(false);
const scenarioValid = ref(false);
const userSession = ref(null)
const selectedMLO = ref(null)
const selectedCompanyTitle = ref(null)
const selectedInspector = ref(null)
const financialInformation = ref({
  propertyState: '',
  propertyCounty: '',
  propertyAddresses: '',
  propertyZipCode: '',
  propertyAuctionDates: '',
  propertyCaseId: '',
  propertyEstimateMarketValue: 0,
  propertyFinalJudmentAmount: 0,
  propertySellPrice: 0,
  propertyClerkFees: 0,
  propertyDocStamps: 0,
  propertyAttorneyHours: 0,
  propertyAttorney: 0,
  propertyArrangment: 0,
  propertyArragmentAmount: 0,
  propertyOtherExpensesAmount: 0,
  propertySellerAgentCommission: 0,
  propertySellerClosingCost: 0,
  propertyBrokerPayment: 0,
  propertyMonths: 0,
  propertyAnnualPropertyTaxes: 0,
  propertyMonthlyPropertyTaxes: 0,
  propertyAnnualPropertyInsurance: 0,
  propertyMonthlyPropertyInsurance: 0,
  propertyAnnualStateTaxes: 0,
  propertyMonthlyStateTaxes: 0,
  propertyAssociationPayment: 0,
  propertyBenefitNetProfitRequired: 0,
  propertyplaceBid: 0
})
const attorneyPrice = ref(0)
const lawyerHourlyPrice = ref(0)
const buyer_agent_commission = ref(0)
const seller_agents_commission = ref(0)

const customer = ref({
  name: '',
  phone: '',
  email: ''
})

const getSession = () => {
  let session =
    localStorage.getItem("usersession") &&
      localStorage.getItem("usersession").length > 0
      ? JSON.parse(localStorage.getItem("usersession"))
      : null;

  if (session) {
    userSession.value = session;
  } else {
    UserService.logout("Session expired!");
  }
}
getSession();

// GET TAXES FROM REALTOR FORM
const getRealtorForm = async () => {
  loading.value = true;
  const response = await axios(
    `${url}realtor-format?user_id=${userSession.value.iduser}`,
    {
      method: "GET",
    }
  );
  if (!response.data.error) {
    if (response.data.auctionCourtPayment) {
      financialInformation.value.propertyClerkFees = response.data.auctionCourtPayment.clerck_fee
      financialInformation.value.propertyDocStamps = response.data.auctionCourtPayment.doc_stamp
      lawyerHourlyPrice.value = response.data.auctionCourtPayment.lawyer_hourly_price
    }
    if (response.data.commissions) {
      buyer_agent_commission.value = response.data.commissions.buyer_agent_commission
      seller_agents_commission.value = response.data.commissions.seller_agents_commission
      financialInformation.value.propertyBrokerPayment = response.data.commissions.real_estate_broker_fee
    }
    if (response.data.attorneyPayment) {
      attorneyPrice.value = response.data.attorneyPayment.number_for_hours
    }
  }
  loading.value = false;
};
getRealtorForm();

const clerckFees = computed(() => {
  return (((financialInformation.value.propertyClerkFees / 100) * financialInformation.value.propertyFinalJudmentAmount)).toFixed(0)
})
const docStamps = computed(() => {
  return (((financialInformation.value.propertyDocStamps / 100) * financialInformation.value.propertyFinalJudmentAmount)).toFixed(0)
})
const attorneyPayment: any = computed(() => {
  return (financialInformation.value.propertyAttorneyHours * lawyerHourlyPrice.value).toFixed(0)
})

const propertyArragmentAmount = computed(() => {
  return ((financialInformation.value.propertySellPrice * (financialInformation.value.propertyArrangment / 100))).toFixed(0)
})

const sellerAgentCommission = computed(() => {
  return (financialInformation.value.propertySellPrice * (seller_agents_commission.value / 100)).toFixed(0)
})


const propertyMonthlyPropertyTaxes = computed(() => {
  return ((financialInformation.value.propertyAnnualPropertyTaxes / 12) * financialInformation.value.propertyMonths).toFixed(0)
})
const propertyMonthlyPropertyInsurance = computed(() => {
  return ((financialInformation.value.propertyAnnualPropertyInsurance / 12) * financialInformation.value.propertyMonths).toFixed(0)
})

const propertyMonthlyStateTaxes = computed(() => {
  return ((financialInformation.value.propertyAnnualStateTaxes / 12) * financialInformation.value.propertyMonths).toFixed(0)
})
const associationMonthlyPayment = computed(() => {
  return ((financialInformation.value.propertyAssociationPayment / 12) * financialInformation.value.propertyMonths).toFixed(0)
})

const totalExpences: any = computed(() => {

  console.log("clerckFees", clerckFees.value)
  console.log("attorneyPayment", attorneyPayment.value)
  console.log("propertyArragmentAmount", propertyArragmentAmount.value)
  console.log("propertyOtherExpensesAmount", financialInformation.value.propertyOtherExpensesAmount)
  console.log("sellerAgentCommission", sellerAgentCommission.value)
  console.log("propertyBrokerPayment", financialInformation.value.propertyBrokerPayment)
  console.log("propertyMonthlyPropertyTaxes", propertyMonthlyPropertyTaxes.value)
  console.log("propertyMonthlyPropertyInsurance", propertyMonthlyPropertyInsurance.value)
  console.log("propertyMonthlyStateTaxes", propertyMonthlyStateTaxes.value)
  console.log("associationMonthlyPayment", associationMonthlyPayment.value)



  return ((parseFloat(clerckFees.value)) +
    (parseFloat(docStamps.value)) +
    parseFloat(attorneyPayment.value) +
    (parseFloat(propertyArragmentAmount.value)) +
    parseFloat(financialInformation.value.propertyOtherExpensesAmount.toString()) +
    parseFloat(sellerAgentCommission.value.toString()) +
    parseFloat(financialInformation.value.propertyBrokerPayment.toString()) +
    parseFloat(propertyMonthlyPropertyTaxes.value) +
    parseFloat(propertyMonthlyPropertyInsurance.value) +
    parseFloat(propertyMonthlyStateTaxes.value) +
    parseFloat(associationMonthlyPayment.value)).toFixed(0)
})


const benefitNetProfit = computed(() => {

  let result = 0
  if (financialInformation.value.propertySellPrice && financialInformation.value.propertyplaceBid) {
    result = financialInformation.value.propertySellPrice - totalExpences.value - financialInformation.value.propertyplaceBid
  }
  return parseFloat(result.toFixed(0))
})


const benefitNetProfitRequired = computed(() => {
  let result = 0
  if (financialInformation.value.propertySellPrice && financialInformation.value.propertyplaceBid) {
    result = ((financialInformation.value.propertySellPrice - totalExpences.value - financialInformation.value.propertyplaceBid) / financialInformation.value.propertySellPrice) * 100
  }
  return parseFloat(result.toFixed(0))

})

const updateParentCompanyTitle = (newCompanyTitle) => {
  selectedCompanyTitle.value = newCompanyTitle;
};

const updateParentInspector = (newInspector) => {
  selectedInspector.value = newInspector;
};

const getData = async () => {
  loading.value = true;
}

const submitScenario = async () => {
  loading.value = true;
  if (!foreign.value) {
    const response = await axios(`${url}realtor-flip-property`, {
      method: "POST",
      data: {
        realtorFlipProperty: [{
          ID: null,
          user_id: userSession.value.iduser,
          scenario_type: "FLIP PROPERTY",
          state: financialInformation.value.propertyState,
          county: financialInformation.value.propertyCounty,
          propertyAddresses: financialInformation.value.propertyAddresses,
          zipcode: financialInformation.value.propertyZipCode,
          auctionDates: financialInformation.value.propertyAuctionDates,
          caseId: financialInformation.value.propertyCaseId,
          marketValue: financialInformation.value.propertyEstimateMarketValue,
          finalJudment: financialInformation.value.propertyFinalJudmentAmount,
          sellPrice: financialInformation.value.propertySellPrice,
          clerckFees: clerckFees.value,
          docStamps: docStamps.value,
          titleCompanyName: selectedCompanyTitle.value.name,
          attorneyHours: financialInformation.value.propertyAttorneyHours,
          attorneyPayment: attorneyPayment.value,
          propertyArragment: financialInformation.value.propertyArrangment,
          propertyArragmentAmount: propertyArragmentAmount.value,
          otherExpenses: financialInformation.value.propertyOtherExpensesAmount,
          sellerAgentCommission: sellerAgentCommission.value,
          brokerPayment: financialInformation.value.propertyBrokerPayment,
          months: financialInformation.value.propertyMonths,
          annualPropertyTaxes: financialInformation.value.propertyAnnualPropertyTaxes,
          propertyTaxes: propertyMonthlyPropertyTaxes.value,
          annualPropertyInsurance: financialInformation.value.propertyAnnualPropertyInsurance,
          propertyInsurance: propertyMonthlyPropertyInsurance.value,
          annualFederalTaxes: financialInformation.value.propertyAnnualStateTaxes,
          federalTaxes: propertyMonthlyStateTaxes.value,
          associationAnnualPayment: financialInformation.value.propertyAssociationPayment,
          associationMonthlyPayment: associationMonthlyPayment.value,
          placeBid: financialInformation.value.propertyplaceBid,
          benefitNetProfit: benefitNetProfit.value,
          benefitNetProfitRequired: benefitNetProfitRequired.value,
          client_name: customer.value.name,
          client_email: customer.value.email

        }],
        customer: {
          ID: null,
          user_id: userSession.value.iduser,
          scenario_type: "FLIP PROPERTY",
          name: customer.value.name,
          phone: customer.value.phone,
          email: customer.value.email
        },
      }

    });

    if (!response.data.error) {
      loading.value = false;
      await toast.success(response.data.message, {
        position: "top-end",
        timer: 3000,
        showCloseButton: true,
      });
    } else {
      loading.value = false;
      await toast.error(response.data.message, {
        position: "top-end",
        timer: 3000,
        showCloseButton: true,
      });
    }
  } else {
    const response = await axios(`${url}realtor-flip-property`, {
      method: "POST",
      data: {
        realtorFlipProperty: [{
          ID: null,
          user_id: userSession.value.iduser,
          scenario_type: "FOREIGN FLIP PROPERTY",
          state: financialInformation.value.propertyState,
          county: financialInformation.value.propertyCounty,
          propertyAddresses: financialInformation.value.propertyAddresses,
          zipcode: financialInformation.value.propertyZipCode,
          auctionDates: financialInformation.value.propertyAuctionDates,
          caseId: financialInformation.value.propertyCaseId,
          marketValue: financialInformation.value.propertyEstimateMarketValue,
          finalJudment: financialInformation.value.propertyFinalJudmentAmount,
          sellPrice: financialInformation.value.propertySellPrice,
          clerckFees: clerckFees.value,
          docStamps: docStamps.value,
          titleCompanyName: selectedCompanyTitle.value.name,
          attorneyHours: financialInformation.value.propertyAttorneyHours,
          attorneyPayment: attorneyPayment.value,
          propertyArragment: financialInformation.value.propertyArrangment,
          propertyArragmentAmount: propertyArragmentAmount.value,
          otherExpenses: financialInformation.value.propertyOtherExpensesAmount,
          sellerAgentCommission: sellerAgentCommission.value,
          brokerPayment: financialInformation.value.propertyBrokerPayment,
          months: financialInformation.value.propertyMonths,
          annualPropertyTaxes: financialInformation.value.propertyAnnualPropertyTaxes,
          propertyTaxes: propertyMonthlyPropertyTaxes.value,
          annualPropertyInsurance: financialInformation.value.propertyAnnualPropertyInsurance,
          propertyInsurance: propertyMonthlyPropertyInsurance.value,
          annualFederalTaxes: financialInformation.value.propertyAnnualStateTaxes,
          federalTaxes: propertyMonthlyStateTaxes.value,
          associationAnnualPayment: financialInformation.value.propertyAssociationPayment,
          associationMonthlyPayment: associationMonthlyPayment.value,
          placeBid: financialInformation.value.propertyplaceBid,
          benefitNetProfit: benefitNetProfit.value,
          benefitNetProfitRequired: benefitNetProfitRequired.value,
          client_name: customer.value.name,
          client_email: customer.value.email

        }],
        customer: {
          ID: null,
          user_id: userSession.value.iduser,
          scenario_type: "FOREIGN FLIP PROPERTY",
          name: customer.value.name,
          phone: customer.value.phone,
          email: customer.value.email
        },
      }

    });

    if (!response.data.error) {
      loading.value = false;
      await toast.success(response.data.message, {
        position: "top-end",
        timer: 3000,
        showCloseButton: true,
      });
    } else {
      loading.value = false;
      await toast.error(response.data.message, {
        position: "top-end",
        timer: 3000,
        showCloseButton: true,
      });
    }
  }
}

return (_ctx: any,_cache: any) => {
  const _component_TopBar = _resolveComponent("TopBar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_unref(foreign))
      ? (_openBlock(), _createBlock(_component_TopBar, {
          key: 0,
          helpBar: true,
          helpDescription: "Video tutorial for the use of the ''FLIP PROPERTY READY''",
          helpVideo: "https://www.realtortools.org/media/Video-Investment-Flip-Ready.mp4"
        }))
      : _createCommentVNode("", true),
    (!_unref(foreign))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(ResidentialView, { header: false })
        ]))
      : _createCommentVNode("", true),
    (!_unref(foreign))
      ? (_openBlock(), _createElementBlock("p", _hoisted_3))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      (!_unref(foreign))
        ? (_openBlock(), _createBlock(SheetPropertyFlip, { key: 0 }))
        : _createCommentVNode("", true),
      (_unref(foreign))
        ? (_openBlock(), _createBlock(SheetForeignFlipReady, { key: 1 }))
        : _createCommentVNode("", true),
      _createVNode(FindA, {
        userSession: userSession.value,
        selectedCompanyTitle: selectedCompanyTitle.value,
        usingInspector: selectedInspector.value,
        isInvestment: true,
        "onUpdate:selectedCompanyTitle": updateParentCompanyTitle,
        "onUpdate:usingInspector": updateParentInspector
      }, null, 8, ["userSession", "selectedCompanyTitle", "usingInspector"]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(MLO, {
          title: "INVESTMENT PROPERTY - FLIP READY",
          userSession: userSession.value,
          usingMLO: selectedMLO.value,
          "onUpdate:usingMLO": _cache[0] || (_cache[0] = ($event: any) => ((selectedMLO).value = $event)),
          customer: customer.value,
          hiddeMLO: true
        }, null, 8, ["userSession", "usingMLO", "customer"])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(PropertyInformation, {
          propertyState: financialInformation.value.propertyState,
          "onUpdate:propertyState": _cache[1] || (_cache[1] = ($event: any) => ((financialInformation.value.propertyState) = $event)),
          propertyCounty: financialInformation.value.propertyCounty,
          "onUpdate:propertyCounty": _cache[2] || (_cache[2] = ($event: any) => ((financialInformation.value.propertyCounty) = $event)),
          propertyAddresses: financialInformation.value.propertyAddresses,
          "onUpdate:propertyAddresses": _cache[3] || (_cache[3] = ($event: any) => ((financialInformation.value.propertyAddresses) = $event)),
          propertyZipCode: financialInformation.value.propertyZipCode,
          "onUpdate:propertyZipCode": _cache[4] || (_cache[4] = ($event: any) => ((financialInformation.value.propertyZipCode) = $event))
        }, null, 8, ["propertyState", "propertyCounty", "propertyAddresses", "propertyZipCode"]),
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("table", _hoisted_10, [
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", _hoisted_11, [
                  _hoisted_12,
                  _createElementVNode("td", _hoisted_13, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((financialInformation.value.propertyAuctionDates) = $event)),
                      placeholder: "00/00/0000"
                    }, null, 512), [
                      [_vModelText, financialInformation.value.propertyAuctionDates]
                    ])
                  ])
                ]),
                _createElementVNode("tr", _hoisted_14, [
                  _hoisted_15,
                  _createElementVNode("td", _hoisted_16, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((financialInformation.value.propertyCaseId) = $event))
                    }, null, 512), [
                      [_vModelText, financialInformation.value.propertyCaseId]
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_17, [
          _hoisted_18,
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("table", _hoisted_20, [
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", _hoisted_21, [
                  _hoisted_22,
                  _createElementVNode("td", _hoisted_23, [
                    _createVNode(_unref(VueNumberFormat), {
                      id: "propertyEstimateMarketValue",
                      value: financialInformation.value.propertyEstimateMarketValue,
                      "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((financialInformation.value.propertyEstimateMarketValue) = $event)),
                      options: { precision: 0, prefix: '$ ', thousand: ',', acceptNegative: false, isInteger: true, decimal: '.' }
                    }, null, 8, ["value", "options"])
                  ])
                ]),
                _createElementVNode("tr", _hoisted_24, [
                  _hoisted_25,
                  _createElementVNode("td", _hoisted_26, [
                    _createVNode(_unref(VueNumberFormat), {
                      id: "propertyFinalJudmentAmount",
                      value: financialInformation.value.propertyFinalJudmentAmount,
                      "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((financialInformation.value.propertyFinalJudmentAmount) = $event)),
                      options: { precision: 0, prefix: '$ ', thousand: ',', acceptNegative: false, isInteger: true, decimal: '.' }
                    }, null, 8, ["value", "options"])
                  ])
                ]),
                _createElementVNode("tr", _hoisted_27, [
                  _hoisted_28,
                  _createElementVNode("td", _hoisted_29, [
                    _createVNode(_unref(VueNumberFormat), {
                      id: "propertySellPriceFlipReady",
                      value: financialInformation.value.propertySellPrice,
                      "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((financialInformation.value.propertySellPrice) = $event)),
                      options: { precision: 0, prefix: '$ ', thousand: ',', acceptNegative: false, isInteger: true, decimal: '.' }
                    }, null, 8, ["value", "options"])
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_30, [
          _hoisted_31,
          _createElementVNode("div", _hoisted_32, [
            _createElementVNode("table", _hoisted_33, [
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", _hoisted_34, [
                  _hoisted_35,
                  _createElementVNode("td", _hoisted_36, [
                    _createVNode(_unref(VueNumberFormat), {
                      id: "propertyPriceTotalCash",
                      value: clerckFees.value,
                      "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((clerckFees).value = $event)),
                      options: { precision: 0, prefix: '$ ', thousand: ',', acceptNegative: false, isInteger: true, decimal: '.' }
                    }, null, 8, ["value", "options"])
                  ])
                ]),
                _createElementVNode("tr", _hoisted_37, [
                  _hoisted_38,
                  _createElementVNode("td", _hoisted_39, [
                    _createVNode(_unref(VueNumberFormat), {
                      id: "propertyPriceTotalCash",
                      value: docStamps.value,
                      "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((docStamps).value = $event)),
                      options: { precision: 0, prefix: '$ ', thousand: ',', acceptNegative: false, isInteger: true, decimal: '.' }
                    }, null, 8, ["value", "options"])
                  ])
                ]),
                _createElementVNode("tr", _hoisted_40, [
                  _hoisted_41,
                  _createElementVNode("td", _hoisted_42, [
                    _withDirectives(_createElementVNode("input", {
                      type: "number",
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((financialInformation.value.propertyAttorneyHours) = $event))
                    }, null, 512), [
                      [_vModelText, financialInformation.value.propertyAttorneyHours]
                    ])
                  ])
                ]),
                _createElementVNode("tr", _hoisted_43, [
                  _hoisted_44,
                  _createElementVNode("td", _hoisted_45, [
                    _createVNode(_unref(VueNumberFormat), {
                      id: "propertyPriceTotalCash",
                      value: attorneyPayment.value,
                      "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((attorneyPayment).value = $event)),
                      options: { precision: 0, prefix: '$ ', thousand: ',', acceptNegative: false, isInteger: true, decimal: '.' }
                    }, null, 8, ["value", "options"])
                  ])
                ]),
                _createElementVNode("tr", _hoisted_46, [
                  _hoisted_47,
                  _createElementVNode("td", _hoisted_48, [
                    _withDirectives(_createElementVNode("input", {
                      type: "number",
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((financialInformation.value.propertyArrangment) = $event))
                    }, null, 512), [
                      [_vModelText, financialInformation.value.propertyArrangment]
                    ])
                  ])
                ]),
                _createElementVNode("tr", _hoisted_49, [
                  _hoisted_50,
                  _createElementVNode("td", _hoisted_51, [
                    _createVNode(_unref(VueNumberFormat), {
                      id: "propertyPriceTotalCash",
                      value: propertyArragmentAmount.value,
                      "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => ((propertyArragmentAmount).value = $event)),
                      options: { precision: 0, prefix: '$ ', thousand: ',', acceptNegative: false, isInteger: false, decimal: '.' }
                    }, null, 8, ["value", "options"])
                  ])
                ]),
                _createElementVNode("tr", _hoisted_52, [
                  _hoisted_53,
                  _createElementVNode("td", _hoisted_54, [
                    _createVNode(_unref(VueNumberFormat), {
                      id: "propertyOtherExpensesAmount",
                      value: financialInformation.value.propertyOtherExpensesAmount,
                      "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => ((financialInformation.value.propertyOtherExpensesAmount) = $event)),
                      options: { precision: 0, prefix: '$ ', thousand: ',', acceptNegative: false, isInteger: true, decimal: '.' }
                    }, null, 8, ["value", "options"])
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_55, [
          _hoisted_56,
          _createElementVNode("div", _hoisted_57, [
            _createElementVNode("table", _hoisted_58, [
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", _hoisted_59, [
                  _hoisted_60,
                  _createElementVNode("td", _hoisted_61, " $" + _toDisplayString(sellerAgentCommission.value), 1)
                ]),
                _createElementVNode("tr", _hoisted_62, [
                  _hoisted_63,
                  _createElementVNode("td", _hoisted_64, [
                    _createVNode(_unref(VueNumberFormat), {
                      id: "propertyOtherExpensesAmount",
                      value: financialInformation.value.propertyBrokerPayment,
                      "onUpdate:value": _cache[17] || (_cache[17] = ($event: any) => ((financialInformation.value.propertyBrokerPayment) = $event)),
                      options: { precision: 0, prefix: '$ ', thousand: ',', acceptNegative: false, isInteger: true, decimal: '.' }
                    }, null, 8, ["value", "options"])
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_65, [
          _hoisted_66,
          _createElementVNode("div", _hoisted_67, [
            _createElementVNode("table", _hoisted_68, [
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", _hoisted_69, [
                  _hoisted_70,
                  _createElementVNode("td", _hoisted_71, [
                    _withDirectives(_createElementVNode("input", {
                      type: "number",
                      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((financialInformation.value.propertyMonths) = $event))
                    }, null, 512), [
                      [_vModelText, financialInformation.value.propertyMonths]
                    ])
                  ])
                ]),
                _createElementVNode("tr", _hoisted_72, [
                  _hoisted_73,
                  _createElementVNode("td", _hoisted_74, [
                    _createVNode(_unref(VueNumberFormat), {
                      id: "propertyOtherExpensesAmount",
                      value: financialInformation.value.propertyAnnualPropertyTaxes,
                      "onUpdate:value": _cache[19] || (_cache[19] = ($event: any) => ((financialInformation.value.propertyAnnualPropertyTaxes) = $event)),
                      options: { precision: 0, prefix: '$ ', thousand: ',', acceptNegative: false, isInteger: true, decimal: '.' }
                    }, null, 8, ["value", "options"])
                  ])
                ]),
                _createElementVNode("tr", _hoisted_75, [
                  _hoisted_76,
                  _createElementVNode("td", _hoisted_77, _toDisplayString(_unref(currencyFormat)(propertyMonthlyPropertyTaxes.value)), 1)
                ]),
                _createElementVNode("tr", _hoisted_78, [
                  _hoisted_79,
                  _createElementVNode("td", _hoisted_80, [
                    _createVNode(_unref(VueNumberFormat), {
                      id: "propertyOtherExpensesAmount",
                      value: financialInformation.value.propertyAnnualPropertyInsurance,
                      "onUpdate:value": _cache[20] || (_cache[20] = ($event: any) => ((financialInformation.value.propertyAnnualPropertyInsurance) = $event)),
                      options: { precision: 0, prefix: '$ ', thousand: ',', acceptNegative: false, isInteger: true, decimal: '.' }
                    }, null, 8, ["value", "options"])
                  ])
                ]),
                _createElementVNode("tr", _hoisted_81, [
                  _hoisted_82,
                  _createElementVNode("td", _hoisted_83, _toDisplayString(_unref(currencyFormat)(propertyMonthlyPropertyInsurance.value)), 1)
                ]),
                _createElementVNode("tr", _hoisted_84, [
                  _hoisted_85,
                  _createElementVNode("td", _hoisted_86, [
                    _createVNode(_unref(VueNumberFormat), {
                      id: "propertyOtherExpensesAmount",
                      value: financialInformation.value.propertyAnnualStateTaxes,
                      "onUpdate:value": _cache[21] || (_cache[21] = ($event: any) => ((financialInformation.value.propertyAnnualStateTaxes) = $event)),
                      options: { precision: 0, prefix: '$ ', thousand: ',', acceptNegative: false, isInteger: true, decimal: '.' }
                    }, null, 8, ["value", "options"])
                  ])
                ]),
                _createElementVNode("tr", _hoisted_87, [
                  _hoisted_88,
                  _createElementVNode("td", _hoisted_89, _toDisplayString(_unref(currencyFormat)(propertyMonthlyStateTaxes.value)), 1)
                ]),
                _createElementVNode("tr", _hoisted_90, [
                  _hoisted_91,
                  _createElementVNode("td", _hoisted_92, [
                    _createVNode(_unref(VueNumberFormat), {
                      id: "propertyAssociationPayment",
                      value: financialInformation.value.propertyAssociationPayment,
                      "onUpdate:value": _cache[22] || (_cache[22] = ($event: any) => ((financialInformation.value.propertyAssociationPayment) = $event)),
                      options: { precision: 0, prefix: '$ ', thousand: ',', acceptNegative: false, isInteger: true, decimal: '.' }
                    }, null, 8, ["value", "options"])
                  ])
                ]),
                _createElementVNode("tr", _hoisted_93, [
                  _hoisted_94,
                  _createElementVNode("td", _hoisted_95, _toDisplayString(_unref(currencyFormat)(associationMonthlyPayment.value)), 1)
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_96, [
          _hoisted_97,
          _createElementVNode("div", _hoisted_98, [
            _createElementVNode("table", _hoisted_99, [
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", _hoisted_100, [
                  _hoisted_101,
                  _createElementVNode("td", _hoisted_102, [
                    _createVNode(_unref(VueNumberFormat), {
                      id: "association",
                      value: financialInformation.value.propertyplaceBid,
                      "onUpdate:value": _cache[23] || (_cache[23] = ($event: any) => ((financialInformation.value.propertyplaceBid) = $event)),
                      options: {
                      precision: 0,
                      prefix: '$ ',
                      thousand: ',',
                      acceptNegative: false,
                      isInteger: false,
                      decimal: '.',
                    },
                      class: "tw-w-full tw-border-[#b6b6b6] tw-outline-none tw-h-[25px] tw-border tw-rounded-lg tw-overflow-hidden tw-px-1 tw-cursor-pointer tw-mt-2"
                    }, null, 8, ["value", "options"])
                  ])
                ])
              ])
            ])
          ])
        ]),
        _hoisted_103,
        _createElementVNode("div", _hoisted_104, [
          _createElementVNode("div", _hoisted_105, [
            _createElementVNode("div", _hoisted_106, [
              _createElementVNode("div", _hoisted_107, [
                _hoisted_108,
                _createVNode(_unref(VueNumberFormat), {
                  id: "association",
                  value: benefitNetProfit.value,
                  "onUpdate:value": _cache[24] || (_cache[24] = ($event: any) => ((benefitNetProfit).value = $event)),
                  options: {
                  precision: 0,
                  prefix: '$ ',
                  thousand: ',',
                  acceptNegative: false,
                  isInteger: false,
                  decimal: '.',
                },
                  class: "tw-bg-[#E6E7E9] tw-border-none tw-rounded-md tw-outline-none tw-h-[40px] tw-px-3"
                }, null, 8, ["value", "options"])
              ]),
              _createElementVNode("div", _hoisted_109, [
                _hoisted_110,
                _createVNode(_unref(VueNumberFormat), {
                  id: "netProfitPercent",
                  value: benefitNetProfitRequired.value,
                  "onUpdate:value": _cache[25] || (_cache[25] = ($event: any) => ((benefitNetProfitRequired).value = $event)),
                  class: "tw-bg-[#E6E7E9] tw-border-none tw-rounded-md tw-outline-none tw-h-[40px] tw-px-3",
                  options: { precision: 0, suffix: '% ', prefix: '', thousand: ',', acceptNegative: false, isInteger: false, decimal: '.' }
                }, null, 8, ["value", "options"])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_111, [
          _createElementVNode("button", {
            onClick: _cache[26] || (_cache[26] = ($event: any) => (submitScenario())),
            class: "tw-bg-[#78c18a] disabled:tw-bg-[#ccc] tw-text-white tw-h-[40px] tw-font-bold tw-w-[250px] tw-rounded-full tw-text-xl"
          }, " SAVE & REGISTER ")
        ])
      ])
    ])
  ]))
}
}

})